import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    subBody:[],
    schedule:{},
    canceldata:{},
    num: '',
    basicinfo: {},
    pwd:''
  },
  mutations: {
    setSubBOdy(state,payload){
      state.subBody = payload
    },
    setschedule(state,payload){
      state.schedule = payload
    },
    setCancelData(state,payload){
      state.canceldata = payload
    },
    changeNum(state,payload){
      state.num = payload
    },
    setbasicData(state,payload){
      state.basicinfo = payload
    },
    setpwdData(state,payload){
      state.pwd = payload
    },
  },
  actions: {
  },
  modules: {
  }
})
